import { FC, memo } from 'react'
import { ArrowContainerNext, ArrowRightIcon } from './styles'

interface Props {
    numberOfSlides?: number
    onClick?: () => void
}

const AvailabilityCalendarNext: FC<Props> = ({ onClick }) => {
    return (
        <ArrowContainerNext onClick={onClick}>
            <ArrowRightIcon />
        </ArrowContainerNext>
    )
}

export default memo(AvailabilityCalendarNext)
